import React, { createContext, useState, useContext, useCallback } from 'react';

const PageHeaderContext = createContext();

export const PageHeaderProvider = ({ children }) => {
    const [title, setTitle] = useState('');

    // Helper to set title
    const setPageTitle = useCallback((newTitle) => {
        setTitle(newTitle);
    }, []);

    // Helper to reset title (e.g., on unmount)
    const resetPageTitle = useCallback(() => {
        setTitle('');
    }, []);

    return (
        <PageHeaderContext.Provider value={{ title, setPageTitle, resetPageTitle }}>
            {children}
        </PageHeaderContext.Provider>
    );
};

export const usePageHeader = () => {
    const context = useContext(PageHeaderContext);
    if (!context) {
        throw new Error('usePageHeader must be used within a PageHeaderProvider');
    }
    return context;
};
